// utils/similarity.js

// Calculates Levenshtein distance and returns a similarity score between 0 and 1
export const calculateSimilarity = (s1, s2) => {
  const longer = s1.length > s2.length ? s1 : s2;
  const shorter = s1.length > s2.length ? s2 : s1;
  const longerLength = longer.length;

  if (longerLength === 0) return 1.0;

  const costs = [];
  for (let i = 0; i <= longerLength; i++) {
    let lastValue = i;
    for (let j = 0; j <= shorter.length; j++) {
      if (i === 0) {
        costs[j] = j;
      } else {
        if (j > 0) {
          let newValue = costs[j - 1];
          if (longer.charAt(i - 1) !== shorter.charAt(j - 1)) {
            newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          }
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[shorter.length] = lastValue;
  }
  return (longerLength - costs[shorter.length]) / parseFloat(longerLength);
};

// Checks against the current student list based on a threshold (80% similarity by default)
export const findSimilarStudent = (
  newName,
  existingStudents,
  threshold = 0.8,
) => {
  const normalizedNewName = newName.trim().toLowerCase();

  for (const student of existingStudents) {
    const similarity = calculateSimilarity(
      normalizedNewName,
      student.full_name.toLowerCase(),
    );
    if (similarity >= threshold) {
      return { student, similarity };
    }
  }
  return null;
};
